// Единая логика "куда делся драг" — общая для HTML5 drop (VariantColumn/VariantsBoard) и
// тач-фолбэка (useTouchDrag), чтобы правила ТЗ не расходились между двумя путями.
import type { DragPayload } from './DndContext';

export interface DropActions {
  addToVariant(variantId: string, segmentId: string, index?: number): void;
  removeFromVariant(variantId: string, segmentId: string): void;
  moveInVariant(variantId: string, from: number, to: number): void;
}

export type DropTarget = { variantId: string; index: number } | null;

/**
 * Правила ТЗ:
 *  - из библиотеки в вариант            -> addToVariant(target, segmentId, index)
 *  - внутри одного варианта             -> moveInVariant(variantId, from, to)
 *  - из варианта наружу (target=null)   -> removeFromVariant(fromVariantId, segmentId)
 *  - из одного варианта в другой        -> addToVariant(target, segmentId, index), копия,
 *                                           исходный вариант не трогаем
 *  - из библиотеки в пустоту (target=null, fromVariantId=null) -> ничего не делаем
 */
export function resolveDrop(actions: DropActions, payload: DragPayload, target: DropTarget): void {
  const { segmentId, fromVariantId, fromIndex } = payload;

  if (target === null) {
    if (fromVariantId) actions.removeFromVariant(fromVariantId, segmentId);
    return;
  }

  if (fromVariantId === target.variantId && fromIndex !== null) {
    // Перестановка внутри того же варианта. target.index — индекс вставки в СПИСКЕ ДО
    // удаления перетаскиваемого элемента (так его вычисляет геометрия по центрам карточек).
    // Если целевая позиция ниже исходной, после удаления элемента список сдвигается на 1 —
    // корректируем, чтобы элемент лёг ровно туда, куда навели курсор.
    let to = target.index;
    if (to > fromIndex) to -= 1;
    if (to !== fromIndex) actions.moveInVariant(target.variantId, fromIndex, to);
    return;
  }

  // Из библиотеки, либо из другого варианта (копия — исходный не трогаем).
  actions.addToVariant(target.variantId, segmentId, target.index);
}
